import { Link } from "gatsby"
import React from "react"
import { Hidden, Visible } from "react-grid-system"
import styled, { css } from "styled-components"
import { Col, Container, Row } from "styleguide/components/grid"
import { HeaderIconShakacode } from "styleguide/icons"
import media from "styleguide/styles/media-queries"
import Menu from "./Nav/Menu/Menu"
import MobileMenu from "./Nav/MobileMenu/MobileMenu"

const StyledHeader = styled.div<{ isHome?: boolean }>`
  width: 100%;
  z-index: 100;
  padding-bottom: 50px;
  ${media.tablet`
    ${props =>
      props.isHome &&
      css`
        width: calc(100% - 30px);
      `}
    background: white;
    position: fixed;
    top: 0px;
    padding-bottom: 0;
  `}
  ${media.phone`
    ${props =>
      props.isHome &&
      css`
        width: calc(100% - 16px);
      `}
  `}
`

const LeftCol = styled(Col)`
  display: flex;
  align-items: center;
`

const RightCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 650px;
`

const StyledContainer = styled(Container)`
  padding-top: 56px;
  ${media.tablet`
    padding-top: 40px;
  `}
`

const StyledLogo = styled(HeaderIconShakacode)`
  ${media.tablet`
    height: 40px;
    width: 170px;
  `}
`

const Header = props => (
  <StyledHeader {...props}>
    <StyledContainer>
      <Row>
        <LeftCol md={5} xs={8}>
          <Link to="/">
            <StyledLogo />
          </Link>
        </LeftCol>
        <RightCol md={7} xs={4}>
          <Hidden sm xs>
            <Menu />
          </Hidden>
          <Visible sm xs>
            <MobileMenu />
          </Visible>
        </RightCol>
      </Row>
    </StyledContainer>
  </StyledHeader>
)

export default Header
